var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "b-toggle",
          rawName: "v-b-toggle",
          value: "task-listing-collapse-" + _vm.index,
          expression: "'task-listing-collapse-'+index"
        }
      ],
      staticClass: "collapse-control",
      class: "task-listing-collapsible-" + _vm.index,
      on: {
        click: function($event) {
          _vm.expanded = !_vm.expanded
          _vm.toggleStatusView(".task-listing-collapsible-" + _vm.index)
        }
      }
    },
    [
      _c("div", { staticClass: "task-exp" }, [
        !_vm.expanded
          ? _c("span", [
              _vm.deliverable.tasks.length == 1
                ? _c("span", [
                    _vm._v(_vm._s(_vm.deliverable.tasks.length)),
                    _c("br"),
                    _vm._v(" TASK"),
                    _c("br")
                  ])
                : _c("span", [
                    _vm._v(_vm._s(_vm.deliverable.tasks.length)),
                    _c("br"),
                    _vm._v(" TASKS")
                  ]),
              _vm._v(" "),
              _vm._m(0)
            ])
          : _c("span", [_c("span", [_vm._v("CLOSE")]), _vm._v(" "), _vm._m(1)])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "task-exp exp-mobile" }, [
        !_vm.expanded ? _c("span", [_vm._m(2)]) : _c("span", [_vm._m(3)])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("img", {
        attrs: { src: require("@/csmworkflow/img/chevron-down.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon close-collase" }, [
      _c("img", { attrs: { src: require("@/csmworkflow/img/chevron-up.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("img", {
        attrs: { src: require("@/csmworkflow/img/chevron-down.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("span", { staticClass: "icon close-collase" }, [
        _c("img", {
          attrs: { src: require("@/csmworkflow/img/chevron-up.svg") }
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }